<template>
  <div class="container">
    <div class="row dado__head">
      <div class="col-12 col-lg-3">
        <div class="title">Test Management</div>
      </div>
      <div class="col-12 col-lg-9">
        <div class="row dado__separately">
          <div class="col-12 col-md-4">
            <label class="dado__label">Survey Language</label>
            <v-select :options="getLangOptions" :flags="true" :search="true" @input="lang = $event"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <v-sidebar/>
      <div class="col-12 col-lg-10">
        <div class="questions__box">
          <div class="row">
            <div class="col-12 col-md-6 mb-4 mb-md-0">
              <div class="questions__topic">Test time (mins)</div>
              <div class="questions__square">
                <input type="text" placeholder="Type here..." v-model.number="form.settings.test_time" class="form__field"/>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="questions__topic">Restart time (hours)</div>
              <div class="questions__square">
                <input type="text" placeholder="Type here..." v-model.number="form.settings.restart_time" class="form__field"/>
              </div>
            </div>
            <div class="col-12 col-md-4 mt-3">
              <div class="questions__topic">Number questions</div>
              <div class="questions__square">
                <input type="text" placeholder="Type here..." v-model.number="form.settings.questions" class="form__field"/>
              </div>
            </div>
            <div class="col-12 col-md-4 mt-3">
              <div class="questions__topic">Correct questions</div>
              <div class="questions__square">
                <input type="text" placeholder="Type here..." v-model.number="form.settings.correct_questions" class="form__field"/>
              </div>
            </div>
            <div class="col-12 col-md-4 mt-3">
              <div class="questions__topic">Attempts</div>
              <div class="questions__square">
                <input type="text" placeholder="Type here..." v-model.number="form.settings.attempts" class="form__field"/>
              </div>
            </div>
          </div>
          <div class="questions__btn mt-5">
            <button class="btn" @click="onSubmit">Submit</button>
          </div>
        </div>
        <div class="questions__set">
          <v-draggable v-model="questions"
                       draggable=".questions__item"
                       handle=".handle"
                       @sort="onSort($event)">
            <div class="questions__item position-relative" v-for="(question, index) of questions" :key="index">
              <div class="questions__head">
                <div class="questions__topic">
                  <span class='questions__force handle'></span>Question {{ question.id }} <span class='questions__tale'></span>
                </div>
                <div class="questions__singly">
                  <div class="questions__setting" @click="onShowEditModal(question)" v-tooltip="'Edit'"></div>
                  <div class="questions__del" @click="onDelete(question)" v-tooltip="'Delete'"></div>
                </div>
              </div>
              <div class="questions__mass">
                <div class="questions__output">
                  <span class='questions__bill'>{{ index + 1 }}</span>{{ question.multiple ? 'Multiple choice' : 'Single choice' }}
                </div>
                <div class="questions__matter">{{ question.text[lang] || question.text['en'] }}</div>
                <div class="questions__checkbox" v-for="answer of question.answers">
                  <label class="checkbox">
                    <input type="checkbox"/>
                    <span class="checkbox__part">
                      <span class="checkbox__text" :class="{'text-success': answer.correct}">
                        {{ answer.text[lang] || answer.text['en'] }}
                      </span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </v-draggable>
        </div>
        <div class="questions__box mb-0">
          <div class="questions__topic"><span class='questions__add'></span>Add a question</div>
          <div class="questions__output">Сhoose the type of question</div>
          <div class="questions__select">
            <vue-select :options="multipleSelect" v-model="questionType" @change="onShowCreateModal($event)"></vue-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: "TestManagement",
    data() {
      return {
        lang: 'en',
        questionType: null,
        questions: [],
        form: {
          settings: {
            test_time: null,
            questions: null,
            correct_questions: null,
            restart_time: null,
            attempts: null,
          }
        },
        multipleSelect: [
          {id: 0, text: 'Single choice'},
          {id: 1, text: 'Multiple choice'},
        ],
      }
    },
    computed: {
      ...mapGetters(
        ['getLangOptions', 'getTestSettings', 'getTestQuestions']
      ),
    },
    mounted() {
      this.queryTestQuestions()
      this.form.settings = this.getTestSettings
    },
    watch: {
      getTestSettings(val) {
        this.form.settings = val
      },
      getTestQuestions(val) {
        this.questions = val
      },
    },
    methods: {
      ...mapActions([
        'showModal',
        'queryTestSettings',
        'updateTestSettings',
        'queryTestQuestions',
        'sortableTestQuestion',
        'deleteTestQuestion',
      ]),
      onShowCreateModal(val) {
        this.showModal({modal: 'ModalTestQuestion', data: {multiple: parseInt(val)}})
        this.$nextTick(() => {
          setTimeout(() => {
            this.questionType = null
          }, 500)
        })
      },
      onShowEditModal(question) {
        this.showModal({modal: 'ModalTestQuestion', data: question})
      },
      onSort(event) {
        this.sortableTestQuestion([event.oldIndex, event.newIndex])
      },
      onDelete(question) {
        this.$confirm({
          message: 'Delete question ' + question.text[this.lang] + '?',
          callback: confirm => {
            if (confirm)
              this.deleteTestQuestion(question.id)
          }
        })
      },
      onSubmit() {
        this.updateTestSettings(this.form.settings)
      }
    }
  }
</script>

<style>

</style>